<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-08 11:00:32
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-12 11:42:04
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<yxCardList>
		<el-checkbox-group v-model="checkedItem" @change="handleCheckedChange">
			<yxCardItem v-for="(row, index) in list" :key="index" class="mt-16">
				<div class="flex flex-align-center flex-just-between" slot="header">
					<div>
						<el-tooltip :content="row.activity_name" placement="top" v-ak-tooltip-auto-show>
							<p class="line-ellipsis-1 yx-color-text-primary font-h4-medium" style="max-width: 500px">{{ row.activity_name }}</p>
						</el-tooltip>
						<p class="recommend" v-if="row.is_top">超盘手推荐</p>
					</div>

					<el-button type="text" class="ml-12" @click="handleViewColonel(row)">
						查看联盟团长主页
						<i class="el-icon-arrow-right"></i>
					</el-button>
				</div>

				<div style="width: 238px" class="pr-12 font-h6-regular">
					<p>
						<span class="yx-color-text-secondary">推广时间：</span>
						<span class="yx-color-text-primary">{{ row.apply_end_time }}</span>
						<span class="yx-color-text-primary">截止</span>
					</p>
					<div class="flex-row">
						<p class="yx-color-text-secondary nowarp">活动要求:</p>
						<el-tooltip placement="top" v-ak-tooltip-auto-show>
							<div slot="content" class="activity-desc-tooltip">
								{{ row.activity_desc }}
							</div>
							<p class="yx-color-text-primary ml-10 line-ellipsis-2" style="width: 100%">{{ row.activity_desc }}</p>
						</el-tooltip>
					</div>
				</div>
				<div class="flex-row-align-center font-h6-regular yx-color-text-primary">
					<span class="nowarp">团长：</span>
					<el-tooltip :content="row.institution_name" placement="top" v-ak-tooltip-auto-show>
						<span class="line-ellipsis-1" style="width: 100%">{{ row.institution_name }}</span>
					</el-tooltip>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">{{ row.commission_rate }}%</p>
					<p class="yx-color-text-secondary">最低佣金</p>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">{{ row.service_rate }}%</p>
					<p class="yx-color-text-secondary">服务费</p>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">
						<span class="mr-4">{{ row.estimated_single_sale }}</span>
						<span>每单品</span>
					</p>
					<p class="yx-color-text-secondary">预估平均成绩销售额(元)</p>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">{{ row.apply_end_time }}</p>
					<p class="yx-color-text-secondary">报名截止</p>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">{{ row.apply_total || 0 }}</p>
					<p class="yx-color-text-secondary">已发起</p>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">{{ row.apply_success || 0 }}</p>
					<p class="yx-color-text-secondary">已报名</p>
				</div>
				<div class="right flex-row-align-center flex-just-end" v-if="$auth.hasPermi('system:colonelActivitySquare:Registered')">
					<div v-if="tabName === '0'">
						<el-button
							:class="[todayCheck(row.apply_end_time) ? 'default' : '']"
							:disabled="todayCheck(row.apply_end_time)"
							@click="signUp(row, '0')"
						>
							立即报名
						</el-button>
					</div>
					<div v-if="tabName === '1'" class="align-center">
						<el-button
							@click="signUp(row, '1')"
							:class="[todayCheck(row.apply_end_time) ? 'default' : '']"
							:disabled="todayCheck(row.apply_end_time)"
						>
							继续报名
						</el-button>
					</div>
				</div>
			</yxCardItem>
		</el-checkbox-group>
	</yxCardList>
</template>
<script>
import yxCardList from '@/components/ui/yxCardList';
import yxCardItem from '@/components/ui/yxCardItem';
import { todayCheck } from '@/utils/validate';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	components: {
		yxCardList,
		yxCardItem,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		selectedList: {
			type: Array,
			default: () => [],
		},
		tabName: {
			type: [String, Number],
			default: '',
		},
	},
	watch: {
		selectedList: {
			handler: function (val) {
				this.checkedItem = val;
			},
			deep: true,
		},
	},
	data() {
		return {
			checkedItem: [],
			todayCheck: todayCheck,
		};
	},
	methods: {
		handleViewColonel(row) {
			row.institution_id && window.open(`https://buyin.jinritemai.com/dashboard/institution/homepage?id=${row.institution_id}&direct=2`, '_blank');
		},
		// 选中单个
		handleCheckedChange(value) {
			let checkedCount = value.length;
			if (checkedCount === this.list.length) {
				this.$emit('changeData', 'allChecked', true);
			}
			this.$emit('changeData', 'isIndeterminate', Number(checkedCount) > 0 && Number(checkedCount) < this.list.length);
			this.checkedItemFn(value);
		},
		// 传出选中信息用于批量操作
		checkedItemFn(val) {
			this.$emit('checkedItemFn', val);
		},
		signUp(row, type) {
			const { activity_id, third_activity_id } = row;
			let handLink = this.$router.resolve({
				path: '/secondColonelManage/colonelActivitySquare/detail',
				query: {
					id: activity_id,
					third_activity_id,
					signUp: type,
					platformId: PLATFORM_DY.value,
					authority_id: row.authority_id || row.authorityId || '',
				},
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.right {
	/deep/ .el-button {
		color: @color-primary !important;
	}

	/deep/ .default {
		color: #cccccc !important;
	}
}
.recommend {
	margin-left: 10px;
	font-size: 12px;
	padding: 0px 8px;
	border-radius: 4px;
	height: 18px;
	line-height: 18px;
	color: #fff;
	background-color: @color-primary;
}

.activity-desc-tooltip {
	max-width: 300px;
}
</style>
